<template>
  <div>
    <d-header></d-header>
    <router-view></router-view>
  </div>
</template>

<script>
import Hello from './components/Hello'
import DHeader from './components/Header'

export default {
  components: {
    Hello,
    DHeader
  }
}
</script>



/** WEBPACK FOOTER **
 ** App.vue?1a30e488
 **/